<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Lista de Históricos' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-row>
    <ion-col size="12" class="ion-padding ion-margin-top">
      <ion-button class="btn-default" expand="block" (click)="addHistorico()">
        {{'Adicionar Histórico' | translate}}
        <ion-icon slot="end" name="add"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>

  <ng-container *ngIf="historicos.length">
    <div class="gradient-extendido-div">
      <div class="div-top">
        <i class="fas fa-list-ul div-icon"></i>

        <ion-label class="color-title">{{'Lista de Históricos' | translate}}</ion-label>
      </div>
    </div>

    <ion-card *ngFor="let d of historicos">
      <ion-grid class="ion-padding">
        <ion-row style="border-bottom: solid 1px #d1d1d1">
          <ion-col size="1">
            <i class="fas fa-list-ul"></i>
          </ion-col>
          <ion-col size="auto">
            <ion-label>
              <p>{{ (d.data !== null) ? (d.data | dateFormat:"media") : '---'}}</p>
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-padding-top">
          <ion-col>
            <h3>{{d.resumo}}</h3>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card>
  </ng-container>

  <div *ngIf="!historicos.length">
    <sem-registro [text]="'Nenhum histórico foi localizado'"></sem-registro>
  </div>
</ion-content>
